import { HsaDecisionMethod } from "@redotech/crdb-enums/conversion/hsa-decision-method";
import { HsaMccReview } from "@redotech/crdb-enums/conversion/hsa-mcc-review";
import { HsaRestrictedReview } from "@redotech/crdb-enums/conversion/hsa-restricted-review";
import { restrictedCategoryMatchSchema } from "@redotech/redo-conversion-hsa-common/hsa-restricted-category";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

const hsaMerchantClassificationProjection_ = z.object({
  inputHash: z.string(),
  restricted: z.boolean(),
  restrictedCategories: z.array(restrictedCategoryMatchSchema),
  restrictedDecidedBy: createEnum(HsaDecisionMethod),
  restrictedActor: z.string(),
  /** The screen model's explanation, shown to the reviewer of a flag. */
  restrictedRationale: z.string().nullable(),
  restrictedReview: createEnum(HsaRestrictedReview),
  reviewedBy: z.string().nullable(),
  reviewedAt: z.date().nullable(),
  reviewNote: z.string().nullable(),
  screenedAt: z.date(),
  primaryMcc: z.string().nullable(),
  industryCode: z.string().nullable(),
  mccConfidence: z.number().nullable(),
  mccAlternatives: z
    .array(z.object({ mcc: z.string(), probability: z.number() }))
    .nullable(),
  mccDecidedBy: createEnum(HsaDecisionMethod).nullable(),
  mccActor: z.string().nullable(),
  classifiedAt: z.date().nullable(),
  mccReview: createEnum(HsaMccReview),
  /** The sellable products and variants the business-line step saw; null before it runs. */
  catalogSize: z
    .object({ productCount: z.number(), variantCount: z.number() })
    .nullable(),
  healthMcc: z.string().nullable(),
  healthIndustryCode: z.string().nullable(),
  healthMccActor: z.string().nullable(),
  appliedAt: z.date().nullable(),
  updatedAt: z.date(),
});
/** The admin view of a team's merchant classification; metadata and evidence stay server-side. */
export const hsaMerchantClassificationProjection: z.ZodType<HsaMerchantClassificationProjection> =
  hsaMerchantClassificationProjection_;
export interface HsaMerchantClassificationProjection extends z.infer<
  typeof hsaMerchantClassificationProjection_
> {}
